// extracted by mini-css-extract-plugin
export default {"emptyState":"styles_emptyState__x-WIw","mainText":"styles_mainText__OYWAR","subText":"styles_subText__U-W0d"};